<div class="w-full flex  justify-start items-stretch flex-col gap-7">
  <div class="w-full flex flex-col gap-2">
    <div
      class="font-bold text-[1.5rem] leading-7 tracking-2percent text-[#333333]"
    >
      {{ cmsLabels.stellar.signIn.userProfile.createNewProfile }}
    </div>
    <div class="tracking-3percen font-normal text-base text-[#737373]">
      {{ cmsLabels.stellar.signIn.userProfile.createNewProfileSubtitle }}
    </div>
  </div>
  <form
    class="flex flex-col gap-[46.25px]"
    [formGroup]="formGroup"
    (ngSubmit)="onSubmit(formGroup.value)"
  >
    <div class="flex flex-col gap-3">
      <ng-container
        *ngFor="let field of userProfileSchema.schemas; let i = index"
      >
        <ng-container *ngIf="field.type === 'object'">
          <div
            [formGroupName]="field.name"
            class="mt-[42px] flex flex-col justify-start gap-2"
          >
            <label
              class="
                font-bold
                tracking-3percen
                text-[12px]
                leading-4
                text-[#737373]
              "
              >{{ getFieldLabel(field.label) }}
              <span
                [class]="
                  getAsteriskClass('dateOfBirth')
                    ? 'text-[#da291c] transition-all duration-75'
                    : null
                "
                >*</span
              >
            </label>
            <div class="flex justify-start items-start gap-4 max-[430px]:gap-2">
              <ng-container
                *ngFor="let childField of objectToArray(field.properties)"
              >
                <div class="w-full">
                  <app-dob
                    [formControlName]="childField.name"
                    [type]="childField.type"
                    [placeholder]="cmsLabels.stellar.signIn.userProfile[childField.label]"
                  ></app-dob>
                  <div class="w-full mt-[1px] h-[15px]">
                    <div
                      *ngIf="
                        formGroup.get(field.name)?.get(childField.name) as control
                      "
                    >
                      <ng-container
                        *ngIf="
                          control.invalid && (control.touched || control.dirty)
                        "
                      >
                        <ng-container *ngIf="!formGroup.get(field.name)?.errors">
                          <ng-container *ngIf="control.errors as errors">
                            <div
                              class="
                                font-normal
                                text-[13px]
                                max-[430px]:text-[12px]
                                text-[#da291c]
                              "
                            >
                              <div *ngIf="errors.required; else checkMinLength">
                                {{
                                  childField.name.charAt(0).toUpperCase() +
                                    childField.name.slice(1)
                                }}
                                required.
                              </div>
                              <ng-template #checkMinLength>
                                <div
                                  *ngIf="errors.minlength; else checkMaxLength"
                                >
                                  Min length
                                  {{ childField.validators?.minLength }}.
                                </div>
                              </ng-template>
                              <ng-template #checkMaxLength>
                                <div *ngIf="errors.maxlength; else checkPattern">
                                  Max length
                                  {{ childField.validators?.maxLength }}.
                                </div>
                              </ng-template>
                              <ng-template #checkPattern>
                                <div *ngIf="errors.pattern">Invalid format.</div>
                              </ng-template>
                            </div>
                          </ng-container>
                        </ng-container>
                      </ng-container>
                    </div>
                    <div
                      *ngIf="
                        !(
                          formGroup.get(field.name)?.get(childField.name)
                            ?.invalid &&
                          (formGroup.get(field.name)?.get(childField.name)
                            ?.touched ||
                            formGroup.get(field.name)?.get(childField.name)
                              ?.dirty)
                        )
                      "
                      class="h-full"
                    ></div>
                  </div>
                </div>
              </ng-container>
            </div>
            <div 
              *ngIf="formGroup.get(field.name)?.errors as groupErrors"
              class="w-full h-[15px] mt-[-23px]"
            >
              <div 
                *ngIf="groupErrors.minAge"
                class="font-normal text-[13px] max-[430px]:text-[12px] text-[#da291c]"
              >
                {{ cmsLabels.stellar.registration.errorMsgs.max }}
              </div>
              <div 
                *ngIf="groupErrors.maxAge"
                class="font-normal text-[13px] max-[430px]:text-[12px] text-[#da291c]"
              >
                {{ cmsLabels.stellar.registration.errorMsgs.min }}
              </div>
              <div 
                *ngIf="groupErrors.invalidDate"
                class="font-normal text-[13px] max-[430px]:text-[12px] text-[#da291c]"
              >
                {{ cmsLabels.stellar.registration.dateOfBirthComponent.enterValidDOB }}.
              </div>
            </div>
          </div>
        </ng-container>
        <ng-container *ngIf="field.type !== 'object'">
          <div
            *ngIf="['country', 'countryOfBirth', 'state', 'senderPrimaryIdentificationIssueCountryCode', 'senderPrimaryIdentificationIssueCountrySubdivisionCode', 'senderPrimaryIdentificationTypeCode'].includes(field.name) && !formGroup.get(field.name)?.disabled"
            #inputContainer
            class="flex flex-col justify-start items-start gap-2 relative"
            (click)="$event.stopPropagation()"
          >
            <label class="font-bold tracking-3percen text-[12px] leading-4 text-[#737373]">
              {{ getFieldLabel(field.label) }}
              <span
                *ngIf="field?.validators?.required"
                [class]="
                  formGroup.get(field.name)?.errors?.required &&
                  formGroup.get(field.name)?.invalid &&
                  formGroup.get(field.name)?.touched
                    ? 'text-[#da291c] transition-all duration-75'
                    : null
                "
              >*</span>
            </label>
            <app-custom-select-input
              class="w-full"
              [formControlName]="field.name"
              [activeDropdown]="activeDropdown"
              [options]="getDropdownOptions(field.name)"
              (focusEvent)="setActiveDropdown(field.name)"
              placeholder="select">
            </app-custom-select-input>
          </div>
          <!-- <div
            class="
              w-full
              flex flex-col
              justify-start
              items-start
              mt-[42px]
              gap-4
            "
            *ngIf="i === 3"
          > -->
            <!-- Remove comment from this when we work on google address lookup -->
            <!-- <img
              class="self-end"
              src="assets\images\powered-by-google.svg"
              alt="powered by google"
            />
            <div
              class="
                h-10
                border
                w-full
                rounded-full
                flex
                gap-2
                p-2
                bg-[#E8E8E8]
              "
            >
              <img
                src="assets\images\form-iOS-search-filled.svg"
                alt="search filled icon"
              />
              <div class="w-full h-6">
                <input
                  id="searchKeyword"
                  [formControl]="locationLookupInput"
                  type="text"
                  name=""
                  id="address-lookup"
                  class="
                    h-6
                    border-none
                    outline-none
                    bg-[#E8E8E8]
                    w-full
                    placeholder:font-bold
                    font-medium
                    text-[14px]
                    leading-5
                    tracking-3percen
                  "
                  placeholder="Find Address"
                />
              </div>
            </div> -->
          <!-- </div> -->
          <ng-container
            *ngIf="!['country', 'countryOfBirth', 'state', 'senderPrimaryIdentificationIssueCountryCode', 'senderPrimaryIdentificationIssueCountrySubdivisionCode', 'senderPrimaryIdentificationTypeCode'].includes(field.name)"
          >
            <label
              [for]="field.name"
              class="
                font-bold
                tracking-3percen
                text-[12px]
                leading-4
                text-[#737373]
              "
              >{{ getFieldLabel(field.label) }}
              <span
                *ngIf="field?.validators?.required"
                [class]="
                  formGroup.get(field.name)?.errors?.required &&
                  formGroup.get(field.name)?.invalid &&
                  formGroup.get(field.name)?.touched
                    ? 'text-[#da291c] transition-all duration-75'
                    : null
                "
                >*</span>
            </label>
            <input
              class="form-input"
              [type]="field.type"
              [placeholder]="field.placeholder ? cmsLabels.stellar.signIn.userProfile[field.placeholder] : ''"
              [formControlName]="field.name"
              [id]="field.name"
            />
          </ng-container>
          <div *ngIf="!formGroup.get(field.name)?.disabled" class="-mt-[calc(16px-5.3866666672px)] w-full h-[15px]">
            <div
              *ngIf="
                formGroup.get(field.name)?.invalid &&
                formGroup.get(field.name)?.touched
              "
              class="
                font-normal
                text-[13px]
                max-[430px]:text-[12px]
                text-[#da291c]
                w-full
              "
            >
              <div *ngIf="formGroup.get(field.name)?.errors?.required">
                {{ getFieldLabel(field.label) }}
                required.
              </div>
              <div *ngIf="formGroup.get(field.name)?.errors?.minlength">
                Min length
                {{ field.validators?.minLength }}.
              </div>
              <div *ngIf="formGroup.get(field.name)?.errors?.maxlength">
                Max length
                {{ field.validators?.maxLength }}.
              </div>
              <div *ngIf="formGroup.get(field.name)?.errors?.pattern">
                {{ getFieldLabel(field.label) }} is invalid.
              </div>
              <div *ngIf="formGroup.get(field.name)?.hasError('invalidOption')">
                {{ getFieldLabel(field.label) }} not found.
              </div>
            </div>
            <div
              *ngIf="
                !(
                  formGroup.get(field.name)?.invalid &&
                  formGroup.get(field.name)?.touched
                )
              "
              class="h-full"
            ></div>
          </div>
        </ng-container>
      </ng-container>
    </div>

    <div
      class="
        self-end
        w-full
        flex
        justify-start
        max-[430px]:justify-center
        items-center
        max-[430px]:pb-[30px]
        pb-12
      "
    >
      <button
        type="submit"
        [class]="
          formGroup.invalid
            ? 'max-[430px]:continue-btn-disabled-mobile-outline continue-btn-disabled-desktop-outline'
            : 'max-[430px]:continue-btn-enabled-mobile-filled continue-btn-enabled-desktop-filled'
        "
        [disabled]="formGroup.invalid"
      >
        <span
          [class]="formGroup.invalid ? 'text-[#B3B3B3]' : 'text-[#FFFFFF]'"
          class="
            font-medium
            leading-6
            tracking-3percen
            text-center
            transition-all
          "
        >
          {{ cmsLabels.stellar.signIn.continue }}
        </span>
      </button>
    </div>
  </form>
</div>
